import { Typography, Card, Button } from 'antd';
import { Link, useNavigate } from 'react-router-dom';
import {
  ArrowLeftOutlined,
  UserOutlined,
  CalendarOutlined,
  FileOutlined,
  SettingOutlined,
  HistoryOutlined,
  StopOutlined,
  ClockCircleOutlined,
  WarningOutlined,
} from '@ant-design/icons';
import './LegalPages.css';

const { Title, Paragraph, Text } = Typography;

const BulletItem = ({ icon, text }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 14 }}>
    <div style={{
      width: 36, height: 36, borderRadius: '50%',
      background: 'var(--wl-primary-pale)', display: 'flex',
      alignItems: 'center', justifyContent: 'center',
      flexShrink: 0,
    }}>
      {icon}
    </div>
    <Text style={{ fontSize: 14 }}>{text}</Text>
  </div>
);

const DeleteAccount = () => {
  const navigate = useNavigate();

  return (
    <div className="legal-page">
      <div className="legal-page-inner" style={{ maxWidth: 640 }}>

        <Card bordered={false} className="legal-card" style={{ textAlign: 'center', padding: '16px 0' }}>
          <div style={{
            width: 72, height: 72, borderRadius: '50%',
            background: 'linear-gradient(135deg, #ff6b6b, #ee5a24)',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 20px',
          }}>
            <UserOutlined style={{ fontSize: 32, color: '#fff' }} />
          </div>

          <Title level={3} style={{ color: 'var(--wl-text)', marginBottom: 4 }}>Delete Your Account</Title>
          <Paragraph type="secondary" style={{ maxWidth: 380, margin: '0 auto 32px' }}>
            We&apos;re sorry to see you go.<br />
            Deleting your account will permanently remove your personal information and associated data.
          </Paragraph>

          <div style={{ textAlign: 'left', padding: '0 24px' }}>
            <Title level={5} style={{ color: 'var(--wl-primary)', marginBottom: 16 }}>What will be deleted?</Title>
            <BulletItem icon={<UserOutlined style={{ color: 'var(--wl-primary)' }} />} text="Profile information" />
            <BulletItem icon={<CalendarOutlined style={{ color: 'var(--wl-primary)' }} />} text="Event registrations" />
            <BulletItem icon={<FileOutlined style={{ color: 'var(--wl-primary)' }} />} text="Uploaded documents" />
            <BulletItem icon={<SettingOutlined style={{ color: 'var(--wl-primary)' }} />} text="Saved preferences" />
            <BulletItem icon={<HistoryOutlined style={{ color: 'var(--wl-primary)' }} />} text="Account history" />

            <Title level={5} style={{ color: 'var(--wl-primary)', marginTop: 28, marginBottom: 16 }}>What happens next?</Title>
            <BulletItem icon={<StopOutlined style={{ color: '#ff4d4f' }} />} text="Your account will be deactivated immediately" />
            <BulletItem icon={<ClockCircleOutlined style={{ color: '#faad14' }} />} text="Data removal may take up to 30 days" />
            <BulletItem icon={<WarningOutlined style={{ color: '#ff4d4f' }} />} text="This action cannot be undone" />
          </div>

          <div style={{ padding: '32px 24px 8px', display: 'flex', flexDirection: 'column', gap: 12 }}>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default DeleteAccount;
